export const getFormIdFromLocation = () => {
    const path = window.location.pathname;

    const split = path.split('/');
    const formId = split[3];

    return formId;
};
